module.exports = __webpack_public_path__ + "media/images/event/bg_m-8e639639fbc17f04805a9e27a0d1a082.png";